import { Component } from '@angular/core';
import { Application } from '@modules/common/types/application';

@Component({
  selector: 'app-mail-layout',
  templateUrl: './mail-layout.component.html',
  styleUrls: ['./mail-layout.component.less', '../../styles.less'],
  standalone: false,
})
export class MailLayoutComponent {
  protected readonly app = Application.mail;
}
